const buyBox = document.querySelector('.quantity-submit-row');
if(buyBox) {
  buyBox.setAttribute('id', 'scroll_target');
  const button = document.querySelector('.buy_btn_box');
  const target = document.getElementById('scroll_target');

  function checkPosition() {
      const rect = target.getBoundingClientRect();
      if (rect.top < 0) {
        button.classList.add('active'); // 画面より上なら表示
      } else {
        button.classList.remove('active'); // 画面内なら非表示
      }
    }

    window.addEventListener("scroll", checkPosition);
    checkPosition(); // 初回実行
}